// Source-owner filters over returned rows only. Never account authorization.
import { UNASSIGNED_KEY } from '../../lib/journey.js'
import styles from './RepBar.module.css'

export default function RepBar({ reps, value, onChange, totalAccounts, showCounts = true }) {
  if (!reps?.length) return null

  const active = value || ''
  const unassigned = reps.find((r) => r.unassigned)
  const N = ({ n }) => (showCounts ? <span className={styles.count}>{n}</span> : null)

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <span className="eyebrow">By source order assignee</span>
        <span className={styles.note}>
          {`${totalAccounts} returned account rows. Source assignees are not current account reps. Multiple source assignees can count the same row more than once.`}
        </span>
      </div>

      <div className={styles.row} role="tablist" aria-label="Filter returned rows by source order assignee">
        <button
          type="button"
          role="tab"
          aria-selected={!active}
          className={`${styles.chip} ${!active ? styles.active : ''}`}
          onClick={() => onChange('')}
        >
          All returned rows
          <N n={totalAccounts} />
        </button>

        {reps.filter((r) => !r.unassigned).map((r) => (
          <button
            key={r.rep}
            type="button"
            role="tab"
            aria-selected={active === r.rep}
            className={`${styles.chip} ${active === r.rep ? styles.active : ''}`}
            onClick={() => onChange(active === r.rep ? '' : r.rep)}
            title={`${r.orders} order${r.orders === 1 ? '' : 's'}${r.attention ? ` · ${r.attention} need attention` : ''}`}
          >
            {r.rep}
            <N n={r.accounts} />
            {r.attention > 0 && <span className={styles.flag} aria-label="needs attention">{r.attention}</span>}
          </button>
        ))}

        {/* Missing source-assignee data is not proof of an unassigned canonical account. */}
        {unassigned && (
          <button
            type="button"
            role="tab"
            aria-selected={active === UNASSIGNED_KEY}
            className={`${styles.chip} ${styles.gap} ${active === UNASSIGNED_KEY ? styles.active : ''}`}
            onClick={() => onChange(active === UNASSIGNED_KEY ? '' : UNASSIGNED_KEY)}
            title="Source assignee not recorded; current account assignment is not inferred"
          >
            Source assignee not recorded
            <N n={unassigned.accounts} />
          </button>
        )}
      </div>
    </div>
  )
}
